import EventNavigation from './EventNavigation';

export default EventNavigation;
